import React from 'react';
import { Chip, Stack } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid, FGridMoneyCell } from '../grid';
type Props = {
  rows: any[];
  selectedId?: any;
  loading?: boolean;
  onSelect: (row: any) => void;
};
export default class PpmGrid extends React.PureComponent<Props> {
  private columns: GridColDef[] = [
    {
      field: 'shc',
      headerName: 'PPM Code',
      width: 175,
      cellClassName: 'ppm-master',
    },
    {
      field: 'nam',
      headerName: 'PPM Name',
      //flex: 1,
      minWidth: 250,
      cellClassName: 'ppm-master',
    },
    {
      field: 'fyr',
      headerName: 'Year',
      width: 80,
      cellClassName: 'ppm-master',
    },
    {
      field: 'psg',
      headerName: 'Maturity',
      width: 150,
      renderCell: (p) => (
        <Chip
          size="small"
          variant={p.value === 'FINAL' ? 'filled' : 'outlined'}
          color={p.value === 'FINAL' ? 'success' : 'warning'}
          label={p.value === 'FINAL' ? 'Final' : 'Pre-approval Draft'}
        />
      ),
      cellClassName: 'ppm-governed',
    },
    {
      field: 'pst',
      headerName: 'Workflow Status',
      width: 170,
      renderCell: (p) => <Chip size="small" label={p.value || '-'} />,
      cellClassName: 'ppm-governed',
    },
    {
      field: 'budget',
      headerName: 'Budget Version',
      width: 220,
      valueGetter: (_v, row: any) =>
        [row.bvc, row.aps].filter(Boolean).join(' · '),
      renderCell: (p) => <Stack sx={{ py: 0.5 }}>{p.value}</Stack>,
      cellClassName: 'ppm-master',
    },
    {
      field: 'lct',
      headerName: 'Lines',
      width: 90,
      type: 'number',
      cellClassName: 'ppm-computed',
    },
    {
      field: 'tam',
      headerName: 'Total',
      width: 160,
      renderCell: FGridMoneyCell,
      cellClassName: 'ppm-computed',
    },
  ];

  render() {
    return (
      <FDataGrid
        title="Procurement Plans"
        subtitle="Pre-approval and final PPM versions for the active Planning Cycle."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={340}
        getRowId={(r: any) => r.rid || r.id}
        onRowClick={(p: any) => this.props.onSelect(p.row)}
        getRowClassName={(p: any) =>
          String(p.row.rid || p.row.id) === String(this.props.selectedId)
            ? 'ppm-selected'
            : ''
        }
        sx={{
          '& .ppm-selected': { bgcolor: 'primary.lighter' },
          '& .ppm-master': { bgcolor: 'info.lighter' },
          '& .ppm-computed': { bgcolor: 'success.lighter', fontWeight: 600 },
          '& .ppm-governed': { bgcolor: 'action.hover' },
          '& .MuiDataGrid-row': { cursor: 'pointer' },
        }}
      />
    );
  }
}
